import React, { FC, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import Checkbox from 'shared/components/andtComponents/Checkbox';
import classnames from 'classnames';
import commonStyles from 'shared/components/CurrencySelect/CurrencySelect.module.scss';
import { InnerSelectSelect } from './InnerSelect';

interface OnboardingCurrencySelectProps {
  property: string;
  label: FC<any>;
  useCheckbox: boolean;
  checkboxText?: string;
  isDisabled?: boolean;
  error?: string;
}

export const OnboardingCurrencySelect: FC<OnboardingCurrencySelectProps> = ({
  property,
  label,
  useCheckbox,
  checkboxText = '',
  isDisabled = true,
  error = '',
}) => {
  const [disabled, setDisabled] = useState<boolean>(isDisabled);
  const { setValue } = useFormContext();

  return useCheckbox ? (
    <>
      {/*@ts-expect-error legacy component*/}
      <Checkbox
        isChecked={!disabled}
        primary={true}
        noPaddings={true}
        onChange={() => {
          const userWantsToDisable = !disabled;
          if (userWantsToDisable) {
            setValue(property, null, { shouldValidate: true });
          }
          setDisabled(userWantsToDisable);
        }}
        text={checkboxText}
      />
      <div className={classnames(commonStyles.currencyBlock, disabled ? commonStyles.disabled : '')}>
        <InnerSelectSelect error={error} disabled={disabled} property={property} label={label}></InnerSelectSelect>
      </div>
    </>
  ) : (
    <InnerSelectSelect error={error} disabled={disabled} property={property} label={label}></InnerSelectSelect>
  );
};
